import { createRouter, createWebHistory } from 'vue-router';
import DataList from '../components/DataList.vue';
import OrderDetails from '../components/OrderDetails.vue';
import SupplierOrders from '../components/SupplierOrders.vue';
import SupplyOrderDetails from '../components/SupplyOrderDetails.vue';
import Login from '../components/Login.vue';

const routes = [
  { path: '/', name: 'DataList', component: DataList },
  { path: '/order/:id', name: 'OrderDetails', component: OrderDetails, props: true },
  { path: '/supplies', name: 'SupplierOrders', component: SupplierOrders },
  { path: '/supply/:id', name: 'SupplyOrderDetails', component: SupplyOrderDetails, props: true },
  { path: '/login', name: 'Login', component: Login },

  { path: '/:pathMatch(.*)*', redirect: '/login' }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;